import { Loader, FilterChip } from "components";
import { useGetSpecialtiesQuery } from "features/api";
import { replaceWithAmpersand } from "helpers";
import FloatingSpan from "./FloatingSpan";

type Specialty = {
  id: string;
  label: string;
  icon: string;
};

interface DoctorsFiltersProps {
  active: string;
  isPremium: boolean;
  onChange(filter: string): void;
  onPremiumChange(isPremium: boolean): void;
  onReset(): void;
}

const DoctorsFilters: React.FC<DoctorsFiltersProps> = ({
  active,
  isPremium,
  onChange,
  onPremiumChange,
  onReset,
}) => {
  const { data: specialties = [], isLoading } =
    useGetSpecialtiesQuery(undefined);

  const handleFilterClick = (newFilter: string) => {
    if (active === newFilter) {
      onChange("");
    } else {
      onChange(newFilter);
    }
  };

  return isLoading ? (
    <Loader
      overlay={false}
      style={{ placeSelf: "center", marginBottom: "8px" }}
    />
  ) : (
    <div>
      <FloatingSpan>
        <FilterChip
          label="mWell+"
          image={process.env.PUBLIC_URL + "/images/badge.svg"}
          active={isPremium}
          color="#e3f2fd"
          overlay="#1565c0"
          onClick={() => onPremiumChange(!isPremium)}
        />
      </FloatingSpan>
      {specialties.map(({ id, label, icon }: Specialty) => (
        <FloatingSpan key={id}>
          <FilterChip
            key={id}
            label={replaceWithAmpersand(label)}
            image={icon}
            active={active === label}
            onClick={() => handleFilterClick(label)}
          />
        </FloatingSpan>
      ))}
      <FloatingSpan>
        <FilterChip
          label="Clear filters"
          onClick={onReset}
          color="#ffebee"
          overlay="#c62828"
          disabled={!isPremium && !active}
        />
      </FloatingSpan>
    </div>
  );
};

export { DoctorsFilters };
